// extracted by mini-css-extract-plugin
export default {"container":"view_container__ycWcy"};